import { render, staticRenderFns } from "./e-saas.vue?vue&type=template&id=7d965a20&scoped=true&"
import script from "./e-saas.vue?vue&type=script&lang=js&"
export * from "./e-saas.vue?vue&type=script&lang=js&"
import style0 from "./e-saas.vue?vue&type=style&index=0&id=7d965a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d965a20",
  null
  
)

export default component.exports